// web/src/theme/fetchBranding.ts
import { parseBranding, type Branding } from "@/theme/branding";

/** Fetch + re-validate a tenant's branding by slug. Returns null on any
 * non-200, null body, network error, or abort — the widget then stays neutral. */
export async function fetchBranding(
  apiBase: string,
  slug: string,
  signal?: AbortSignal,
): Promise<Branding | null> {
  try {
    const base = apiBase.replace(/\/+$/, "");
    const res = await fetch(`${base}/api/theme/${encodeURIComponent(slug)}`, { signal });
    if (!res.ok) return null;
    const body = (await res.json()) as { branding?: unknown } | null;
    const raw = body?.branding;
    if (raw == null) return null;
    return parseBranding(raw);
  } catch {
    return null;
  }
}
